<template>
    <div :class="['backdrop', { 'fixed-top vh-100 vw-100': show }, { show, fade }]">
        <div class="fixed-center" :style="[{ 'z-index': show ? 1071 : null }]">
            <slot name="default" />
        </div>
    </div>
</template>

<script>
export default {
    name: 'backdrop',
    props: {
        show: {
            type: Boolean,
            required: true
        }
    },
    data () {
        return {
            fade: true
        }
    },
    computed: {},
    watch: {
        show: {
            immediate: true,
            handler (status) {
                if (typeof status !== 'undefined') {
                    setTimeout(() => { this.fade = !status }, 700);
                }
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.backdrop {
    display: none;
    opacity: 1;
    outline: 0;
    overflow: hidden;
    transition: opacity 0.3s linear;
    z-index: 0;

    &.show {
        background-color: rgba(30, 30, 30, 0.5);
        z-index: 9999;
    }

    &.fade {
        opacity: 0;
    }

    &.show {
        display: block;
    }
}
</style>